import axios from "axios";
import router from "@/router";
import Cookies from "js-cookie";
import { useNotificationStore } from "@/store/NotificationStore";
import { useAuthStore } from "@/store/AuthStore";
//import { useErrorsStore } from "@/store/errorsStore";

const baseURL =
    (window.env && window.env.BASE_URL)
        ? window.env.BASE_URL
        // : "http://192.168.2.24:8080/api/v1";
        : "http://localhost:8080/api/v1";

export var api = axios.create({
    baseURL: baseURL,
});

export const setAccessToken = (token) => {
    Cookies.set('access_token', token);
}

export const removeAccessToken = () => {
    Cookies.remove('access_token');
}

let refreshPromise = null;

// Единый lock для refresh — используется и интерцептором, и chatSocket
export const getRefreshPromise = () => refreshPromise;
export const runRefreshOnce = (authStore) => {
    if (!refreshPromise) {
        refreshPromise = authStore.refreshToken().finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
};

export const setInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.request.use((config) => {
        const token = Cookies.get('access_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    });

    // Добавляем перехватчик ответов
    axiosInstance.interceptors.response.use(
        (response) => {
            // Check if response data is just text
            if (typeof response.data === 'string' && response.data.trim().length > 0 && !response.config.skipSuccessNotification) {
                try {
                    const notificationStore = useNotificationStore();
                    notificationStore.addNotification({ message: response.data, type: 'success' });
                } catch (e) {
                    // Pinia might not be ready or other issue
                    console.error('Notification error:', e);
                }
            }
            return response;
        },
        async (error) => {
            // Любые ошибки за пределами диапазона 2xx вызовут эту функцию
            // console.log(error)

            const notificationStore = useNotificationStore();
            const { status, data } = error.response || {};

            if (data && data.message && !error.config?.skipErrorNotification) {
                notificationStore.addNotification({ message: data.message, type: 'error' });
            }

            // Глобальная обработка ошибок
            switch (status) {
                case 400:
                    //useErrorsStore().addError(400, "Неверный запрос", data);
                    console.error("Ошибка 400: Неверный запрос", data);
                    break;
                case 401:
                    console.error("Ошибка 401: Неавторизован", data);
                    // Пробуем обновить токен, если это не сам запрос на refresh
                    if (!error.config._isRefreshRequest && !error.config._isRetry) {
                        try {
                            const authStore = useAuthStore();
                            const newToken = await runRefreshOnce(authStore);
                            if (newToken) {
                                error.config._isRetry = true;
                                error.config.headers['Authorization'] = `Bearer ${newToken}`;
                                return axiosInstance(error.config);
                            }
                        } catch (refreshError) {
                            console.error("Ошибка refresh токена:", refreshError);
                        }
                        // Refresh не удался — на логин
                        Cookies.remove('access_token');
                        removeAccessToken();
                        router.push('/login');
                    } else {
                        // Cookies.remove('access_token');
                        // removeAccessToken();
                        // router.push('/login');
                    }
                    break;
                case 403:
                    console.error("Ошибка 403: Доступ запрещен", data);
                    // router.back();
                    break;
                case 404:
                    console.error("Ошибка 404: Ресурс не найден", data);
                    break;
                case 500:
                    // console.log(error)
                    console.error("Ошибка 500: Ошибка сервера", data);
                    break;
                default:
                    console.error("Неизвестная ошибка", error);
            }

            // Пробрасываем ошибку дальше, чтобы её можно было обработать локально (в catch)
            return Promise.reject(error);
        }
    );
}

setInterceptors(api);

export default { setAccessToken, api };
